/* Drukke Mama's — productaanbevelingen met intent-fallback.
   Haalt eerst complementaire aanbevelingen op (Shopify Search & Discovery);
   levert dat niets op, dan vallen we terug op 'related'. Gebruik:

   <dm-recommendations data-url="{{ routes.product_recommendations_url }}"
     data-product-id="..." data-section-id="..." data-limit="10" data-intent="complementary">
   </dm-recommendations> */

class DmRecommendations extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(this.dataset.intent || 'related');
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  buildUrl(intent) {
    return (
      `${this.dataset.url}?product_id=${this.dataset.productId}` +
      `&limit=${this.dataset.limit || 10}&section_id=${this.dataset.sectionId}&intent=${intent}`
    );
  }

  loadRecommendations(intent) {
    fetch(this.buildUrl(intent))
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('dm-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else if (intent === 'complementary') {
          // Geen complementaire producten ingesteld — toon gerelateerde producten.
          this.loadRecommendations('related');
        } else {
          // Ook geen gerelateerde producten: sectie stilletjes verbergen.
          this.closest('.section, section')?.classList.add('hidden');
          this.hidden = true;
        }
      })
      .catch((error) => console.error(error));
  }
}

if (!customElements.get('dm-recommendations')) customElements.define('dm-recommendations', DmRecommendations);
